export const ADD_PROJECT_STEPS = 'ADD_PROJECT_STEPS'
export const ADD_PROJECT_STEP = 'ADD_PROJECT_STEP'
export const UPDATE_PROJECT_STEP = 'UPDATE_PROJECT_STEP'
export const DESTROY_PROJECT_STEP = 'DESTROY_PROJECT_STEP'
export const ADD_PROJECT_STEPS_WITH_TASKS = 'ADD_PROJECT_STEPS_WITH_TASKS'